/* eslint-disable no-return-assign */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import connectWallet from "../assets/1.png";
import disconnectWallet from "../assets/disconnect.png";

function WalletConnectButton() {
  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        authenticationStatus,
        mounted
      }) => {
        // Note: If your app doesn't use authentication, you
        // can remove all 'authenticationStatus' checks
        const ready = mounted && authenticationStatus !== "loading";
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus || authenticationStatus === "authenticated");

        return (
          <div
            {...(!ready && {
              "aria-hidden": true,
              style: {
                opacity: 0,
                pointerEvents: "none",
                userSelect: "none"
              }
            })}
          >
            {(() => {
              if (!connected) {
                return (
                  <div class="fixed left-0 top-0 flex h-screen w-screen items-center justify-center">
                    <div
                      onClick={() => {
                        openConnectModal();
                      }}
                    >
                      <img
                        className="w-[110vw] max-w-[900px]"
                        src={connectWallet}
                        alt="connect wallet"
                      />
                    </div>
                  </div>
                );
              }

              if (chain.unsupported) {
                return (
                  <div className="text-white" onClick={openChainModal}>
                    switch Chain
                  </div>
                );
              }

              return (
                <div
                  className="absolute"
                  onClick={() => {
                    openAccountModal();
                  }}
                >
                  <img className=" w-[300px]" src={disconnectWallet} alt="connect wallet" />
                </div>
              );
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
}

export default WalletConnectButton;
